import { pick } from 'ramda';
import { useMemo } from 'react';
import { useAppSelector } from 'js/store/hooks';
import { useTranslations } from 'js/hooks/i18n';

export const useFbPublicAPI = () => {
    const { facebookClientID, facebookSuccessURL, facebookProxyURL } =
        useAppSelector(pick(['facebookClientID', 'facebookSuccessURL', 'facebookProxyURL']));
    const t = useTranslations();

    return useMemo(() => ({
        /**
         * Get list of configured facebook settings.
         * @memberOf Playtech.API.fb
         * @function
         * @returns {{facebookClientID: String, facebookSuccessURL: String, facebookProxyURL: String, t: Function}} Where t is translations function.
         * @example
         * // {facebookClientID: '234606480943397', facebookSuccessURL: '/register', facebookProxyURL: 'https://src-cmsi05.ptstaging.eu/_hub2_facebook_registration', t: ƒ}
         * Playtech.API.fb.getConfig();
         */
        getConfig: () => ({ facebookClientID, facebookSuccessURL, facebookProxyURL, t })
    }), [facebookClientID, facebookSuccessURL, facebookProxyURL, t]);
};
